<template>
     <div ref="accountedEcharts" style="width:100%;height:100%" class="center" />
</template>

<script>
export const loadBMap = (ak)=> {
    return new Promise(function(resolve, reject) {
        if (typeof BMap !== 'undefined') {
            resolve(BMap)
            return true
        }
        window.onBMapCallback = function() {
            resolve(BMap)
        }
        let script = document.createElement('script')
        script.type = 'text/javascript'
        script.src =
            'http://api.map.baidu.com/api?v=2.0&ak=' + ak + '&callback=onBMapCallback'
        script.onerror = reject
        document.head.appendChild(script)
    })
}
import { mapState } from "vuex";
import Public from "@/public";
import {data,geoCoordMap} from "@/util/map"
var echarts = require('echarts');
require('echarts/extension/bmap/bmap');

const convertData = function (data) {
  var res = [];
  for (var i = 0; i < data.length; i++) {
    var geoCoord = geoCoordMap[data[i].name];
    if (geoCoord) {
      res.push({
        name: data[i].name,
        value: geoCoord.concat(data[i].value)
      });
    }
  }
  return res;
};
export default {
    data() {
        let self = this;
        return {
            chart: null,
        }
    },
    mounted() {
        loadBMap("E1ApfPwSdD6sz1UGw6wotWO4QBdORjYn")
        .then(() => {
             this.chart = echarts.init(this.$refs.accountedEcharts);
        /*在这里初始化你的echart,也就是let chartDom = document.getElementById('baidu-map');
            let myChart = echarts.init(chartDom);...那一大串*/
            this.dataEcharts()
        }).catch((err)=>{
            console.log(err);
        });
    },
    methods: {
        dataEcharts() {
            console.log(this.data)
            this.chart.setOption({
                 title: {
                    text: '全国主要城市空气质量 - 百度地图',
                    subtext: 'data from PM25.in',
                    sublink: 'http://www.pm25.in',
                    left: 'center'
                  },
                  tooltip: {
                    trigger: 'item'
                  },
                  bmap: {
                    center: [115.904539, 28.686507],
                    zoom: 10,
                    roam: true,
                    mapStyle: {
                      styleJson: [
                        {
                          featureType: 'water',
                          elementType: 'all',
                          stylers: {
                            color: '#d1d1d1'
                          }
                        },
                        {
                          featureType: 'land',
                          elementType: 'all',
                          stylers: {
                            color: '#f3f3f3'
                          }
                        },
                        {
                          featureType: 'railway',
                          elementType: 'all',
                          stylers: {
                            visibility: 'off'
                          }
                        },
                        {
                          featureType: 'highway',
                          elementType: 'all',
                          stylers: {
                            color: '#fdfdfd'
                          }
                        },
                        {
                          featureType: 'highway',
                          elementType: 'labels',
                          stylers: {
                            visibility: 'off'
                          }
                        },
                        {
                          featureType: 'arterial',
                          elementType: 'geometry',
                          stylers: {
                            color: '#fefefe'
                          }
                        },
                        {
                          featureType: 'arterial',
                          elementType: 'geometry.fill',
                          stylers: {
                            color: '#fefefe'
                          }
                        },
                        {
                          featureType: 'poi',
                          elementType: 'all',
                          stylers: {
                            visibility: 'off'
                          }
                        },
                        {
                          featureType: 'green',
                          elementType: 'all',
                          stylers: {
                            visibility: 'off'
                          }
                        },
                        {
                          featureType: 'subway',
                          elementType: 'all',
                          stylers: {
                            visibility: 'off'
                          }
                        },
                        {
                          featureType: 'manmade',
                          elementType: 'all',
                          stylers: {
                            color: '#d1d1d1'
                          }
                        },
                        {
                          featureType: 'local',
                          elementType: 'all',
                          stylers: {
                            color: '#d1d1d1'
                          }
                        },
                        {
                          featureType: 'arterial',
                          elementType: 'labels',
                          stylers: {
                            visibility: 'off'
                          }
                        },
                        {
                          featureType: 'boundary',
                          elementType: 'all',
                          stylers: {
                            color: '#fefefe'
                          }
                        },
                        {
                          featureType: 'building',
                          elementType: 'all',
                          stylers: {
                            color: '#d1d1d1'
                          }
                        },
                        {
                          featureType: 'label',
                          elementType: 'labels.text.fill',
                          stylers: {
                            color: '#999999'
                          }
                        }
                      ]
                    }
                  },
                  series: [
                    {
                      name: 'pm2.5',
                      type: 'scatter',
                      coordinateSystem: 'bmap',
                      data: convertData(data),
                      symbolSize: function (val) {
                        return val[2] / 10;
                      },
                      encode: {
                        value: 2
                      },
                      label: {
                        formatter: '{b}',
                        position: 'right',
                        show: false
                      },
                      emphasis: {
                        label: {
                          show: true
                        }
                      }
                    },
                    {
                      name: 'Top 5',
                      type: 'effectScatter',
                      coordinateSystem: 'bmap',
                      data: convertData(
                        data
                          .sort(function (a, b) {
                            return b.value - a.value;
                          })
                          .slice(0, 6)
                      ),
                      symbolSize: function (val) {
                        return val[2] / 10;
                      },
                      encode: {
                        value: 2
                      },
                      showEffectOn: 'render',
                      rippleEffect: {
                        brushType: 'stroke'
                      },
                      label: {
                        formatter: '{b}',
                        position: 'right',
                        show: true
                      },
                      itemStyle: {
                        shadowBlur: 10,
                        shadowColor: '#333'
                      },
                      emphasis: {
                        scale: true
                      },
                      zlevel: 1
                    }
                  ]
            });
        },
        
    }
}
</script>

<style>
.amap-page-container {
    width: 100%;
    height: 100%;
}
</style>